import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ReceiptModal } from '@shared/models/receipt-modal';
import { ReceiptContent } from '@shared/services/content/content-jsons/receipt-content';
import { ButtonComponent } from '@vg-constellation/angular-16/button';
import { ModalDialogComponent } from '@vg-constellation/angular-16/modal-dialog';
import { Subscription } from 'rxjs';

import { ReceiptModalService } from './receipt-modal.service';

@Component({
  selector: 'app-receipt-modal',
  templateUrl: './receipt-modal.component.html',
  styleUrls: ['./receipt-modal.component.scss'],
  standalone: true,
  imports: [ModalDialogComponent, ButtonComponent],
})
export class ReceiptModalComponent implements OnInit, OnDestroy {
  constructor(private receiptModalService: ReceiptModalService) {}
  content = ReceiptContent;
  subscription: Subscription;

  @ViewChild('divCapGainsModal') divCapGainsModal;
  @ViewChild('settlementFundModal') settlementFundModal;
  @ViewChild('beneficiariesModal') beneficiariesModal;

  ngOnInit(): void {
    this.subscription = this.receiptModalService.receiptModal$.subscribe((next: ReceiptModal) => {
      this.openModal(next);
    });
  }

  openModal(modal: ReceiptModal) {
    const modalId = modal.split('_')[0];

    switch (modalId) {
      case ReceiptModal.DIVCAPGAINS:
        this.divCapGainsModal.openModalDialog();
        break;
      case ReceiptModal.SETTLEMENTFUND:
        this.settlementFundModal.openModalDialog();
        break;
      case ReceiptModal.BENEFICIARIES:
        this.beneficiariesModal.openModalDialog();
        break;
    }
  }

  closeDivCapModal() {
    this.divCapGainsModal.closeDialogModal();
  }

  closeSettlementModal() {
    this.settlementFundModal.closeDialogModal();
  }

  closeBeneficiariesModal() {
    this.beneficiariesModal.closeDialogModal();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
